module.exports = __webpack_public_path__ + "img/PerluDiproses.64c8a9a2.svg";